import { gridPaths } from '@/shared/hooks';
import { createEntityGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchSuitesGrid } from './gridQuery';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { SuiteListItemDto } from '@flowqa/shared';

export const suitesGridConfig = ({
  projectId,
  organisationId,
  fixedFilters,
  initialSortModel = [{ field: 'latestExecutionTimestamp', sort: 'desc' }],
  initialFilterModel,
  persistKey,
  includeDeltas = true,
  syncStateToUrl = false,
}: {
  projectId?: string | null;
  organisationId?: string | null;
  fixedFilters?: GridQueryInput['filters'];
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  includeDeltas?: boolean;
  syncStateToUrl?: boolean;
} = {}): GridConfig<SuiteListItemDto> =>
  createEntityGridConfig<SuiteListItemDto>({
    path: gridPaths.suites,
    queryFn: async (input) =>
      await fetchSuitesGrid(input, projectId, organisationId, includeDeltas),
    noRowsText: 'No suites found',
    fixedFilters,
    initialSortModel,
    initialFilterModel,
    persistKey,
    defaultPersistKey: 'suites',
    syncStateToUrl,
  });

export type SuitesGridConfig = ReturnType<typeof suitesGridConfig>;
